import React from "react";

const ResumeTitle = ({ title }) => {
  return (
    <h1 className="text-lg text-gray-300 italic uppercase font-medium flex justify-center items-center gap-2 py-3 border-b-[1px] border-b-zinc-800">
      {title}
    </h1>
  );
};

export default ResumeTitle;
